module.exports = __webpack_public_path__ + "img/rt.6951231d.svg";